import { getId } from '@atlassian/conversation-assistant-service/services/assistance-service/utils/data';
import {
	isStoreAssistant,
	type StoreMessage,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const getStoreMessageId = (storeMessage: StoreMessage): string => {
	if (isStoreAssistant(storeMessage)) {
		return getId(storeMessage.content);
	}
	return storeMessage.content.id;
};
